import api from './api';

const ENDPOINT = 'rankings';

const RankingService = {
    getClientRanking: (id) => api.get(`${ENDPOINT}/${id}`),
};

export default RankingService;
